import { graphql, useStaticQuery } from 'gatsby';
import React, { FC } from 'react';

import { keysToCamel } from '@utils/butter';

import FlowFooter, { IFlowFooterContent } from './FlowFooter.component';

interface IFlowFooterWrapperProps {
	stepKey?: string;
}

const FlowFooterWrapper: FC<IFlowFooterWrapperProps> = ({ stepKey }) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "flow-footer" }) {
				logged_in {
					text
					cta
				}
				logged_out {
					text
					cta
				}
			}
		}
	`);

	const refinedContent: IFlowFooterContent = keysToCamel(pageContent) as IFlowFooterContent;

	return <FlowFooter footerContent={refinedContent} stepKey={stepKey} />;
};

export default FlowFooterWrapper;
